import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { Divider, MenuItem } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { $savedFilters } from '../../../model';
import { SavedFilter } from '../../../types';
import { Props } from '../../page';
import * as Styled from '../styled';

export const SavedFiltersList = ({
  checkedSavedFilters,
  isDivider,
  setFiltersOutside,
  handleClose,
}: {
  checkedSavedFilters?: SavedFilter;
  isDivider: boolean;
  setFiltersOutside: Props['setFiltersOutside'];
  handleClose: () => void;
}) => {
  const [savedFilters] = useUnit([$savedFilters]);

  const { t } = useTranslation();

  if (!savedFilters.length) return null;

  return (
    <>
      {isDivider && <Divider />}

      <Styled.ListSubheader>{t('SavedFilters')}</Styled.ListSubheader>

      {savedFilters.map(({ name, filtersJsonString }) => {
        const isChecked = checkedSavedFilters?.name === name;

        const setFiltersOutsideFunc = () => {
          try {
            setFiltersOutside(JSON.parse(filtersJsonString));
            handleClose();
          } catch (e) {
            // eslint-disable-next-line no-console
            console.warn('error setFiltersOutsideFunc', e);
          }
        };

        return (
          <MenuItem key={name} disableRipple onClick={setFiltersOutsideFunc}>
            {checkedSavedFilters && (
              <Styled.CheckedMark>{isChecked && <CheckIcon />}</Styled.CheckedMark>
            )}
            {name}
          </MenuItem>
        );
      })}
    </>
  );
};
